module.exports = __webpack_public_path__ + "img/IMG_9022_L_Foamcore.0c0170c7.jpg";